import {
  ClipboardDocumentIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';
import ButtonExternal from '@teetsh/app/src/components/Buttons/ExternalLink';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useIsDirectorByUrl } from '@teetsh/app/src/hooks/useIsDirectorByUrl';
import React from 'react';
import { useTranslation } from 'react-i18next';
import 'twin.macro';

export function ContactUs() {
  const { t } = useTranslation(['userSettings', 'common']);
  const { notifySuccess } = useNotification();
  const isDirectorByUrl = useIsDirectorByUrl();

  return (
    <TwoColumnsCardSidebar.Section
      title={
        <div tw="flex items-center gap-2">
          <EnvelopeIcon tw="h-6 w-6" />
          {t('userSettings:contact.title')}
        </div>
      }
    >
      <div>
        <p tw="text-base mb-2">
          <span tw="font-semibold">
            {t('userSettings:contact.support.description')}
          </span>{' '}
          {t('userSettings:contact.support.contactUs')}
        </p>
        <div tw="flex items-center gap-2">
          <a
            href="mailto:hello@teetsh.com"
            tw="text-brand-intense hover:underline"
          >
            hello@teetsh.com
          </a>
          <Button
            small
            icon={ClipboardDocumentIcon}
            outlined
            intent="primary"
            onClick={() => {
              navigator.clipboard.writeText('hello@teetsh.com');
              notifySuccess({
                title: t('common:buttons.copied'),
              });
            }}
            aria-label={t('common:buttons.copyLink')}
          />
          <ButtonExternal
            small
            icon={EnvelopeIcon}
            outlined
            intent="primary"
            href="mailto:hello@teetsh.com"
          />
        </div>
        {isDirectorByUrl && (
          <div>
            <p tw="text-base my-2">
              <span tw="font-semibold">
                {t('userSettings:contact.contactUs.licenseSchool.description')}
              </span>{' '}
              {t('userSettings:contact.support.contactUs')}
            </p>
            <div tw="flex items-center gap-2">
              <a
                href="mailto:ecoles@teetsh.com"
                tw="text-brand-intense hover:underline"
              >
                ecoles@teetsh.com
              </a>
              <Button
                small
                icon={ClipboardDocumentIcon}
                outlined
                intent="primary"
                onClick={() => {
                  navigator.clipboard.writeText('hello@teetsh.com');
                  notifySuccess({
                    title: t('common:buttons.copied'),
                  });
                }}
                aria-label={t('common:buttons.copyLink')}
              />
              <ButtonExternal
                small
                icon={EnvelopeIcon}
                outlined
                intent="primary"
                href="mailto:hello@teetsh.com"
              />
            </div>
          </div>
        )}
      </div>
    </TwoColumnsCardSidebar.Section>
  );
}
